'use client';

import Image from 'next/image';

export default function BWTHLogoWithBlueBackground() {
  return (
    <div className="bg-primary dark:bg-boxdark p-7 rounded-2xl">
      <Image
        width={350}
        height={150}
        src={'/logos/bwth-logo-light.svg'}
        alt="Logo"
      />
    </div>
  );
}
